export function devLog(...args: unknown[]) {
  if (process.env.NODE_ENV === 'development') {
    const prettyArgs = args.map(arg =>
      typeof arg === 'object' && arg !== null
        ? JSON.stringify(arg, null, 2)
        : arg
    );
    console.debug('DEV LOG:', ...prettyArgs);
  }
}
